import { Fragment, ReactNode } from 'react'

import Loading from './Loading'

type AsyncListDataComponentProps<T extends Object = {}> = {
  isLoading: boolean
  isLoaded?: boolean
  isSuccess?: boolean
  children: (data: T[]) => ReactNode
  renderLoading?(...args: unknown[]): unknown
  data?: T[]
  placeholder?: ReactNode
}

const AsyncListDataComponent = <T extends Object = {}>({
  isLoading,

  // TODO: after integrate to rtk query, this can be removed
  isLoaded,

  isSuccess,
  data = [],
  placeholder,
  renderLoading,
  children,
}: AsyncListDataComponentProps<T>) => {
  return (
    <Fragment>
      {/* Loading */}
      {(() => {
        if (isLoading && data.length === 0) {
          return typeof renderLoading === 'function' ? (
            renderLoading()
          ) : (
            <Loading />
          )
        }
      })()}

      {/* Loaded with empty data */}
      {!isLoading &&
        (isLoaded || isSuccess) &&
        placeholder &&
        data.length === 0 && (
          <div className="Placeholder">
            <p className="Placeholder__p">{placeholder}</p>
          </div>
        )}

      {/* Loaded with data */}
      {data.length > 0 ? children(data) : null}
    </Fragment>
  )
}

export default AsyncListDataComponent
